
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.6 11.182a2.182 2.182 0 100-4.364 2.182 2.182 0 000 4.364z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.982 11.182a1.2 1.2 0 00.24 1.323l.044.044a1.455 1.455 0 11-2.059 2.058l-.043-.043a1.2 1.2 0 00-1.324-.24 1.2 1.2 0 00-.727 1.098v.123a1.455 1.455 0 01-2.91 0v-.065a1.2 1.2 0 00-.785-1.098 1.2 1.2 0 00-1.323.24l-.044.043a1.455 1.455 0 11-2.058-2.058l.043-.043a1.2 1.2 0 00.24-1.324 1.2 1.2 0 00-1.098-.727h-.123a1.454 1.454 0 110-2.91h.065a1.2 1.2 0 001.098-.785 1.2 1.2 0 00-.24-1.323l-.043-.044a1.455 1.455 0 112.058-2.058l.043.043a1.2 1.2 0 001.324.24h.058a1.2 1.2 0 00.728-1.098v-.123a1.455 1.455 0 012.909 0v.065a1.2 1.2 0 00.727 1.098 1.2 1.2 0 001.324-.24l.043-.043a1.455 1.455 0 112.058 2.058l-.043.043a1.2 1.2 0 00-.24 1.324v.058a1.2 1.2 0 001.098.727h.124a1.455 1.455 0 010 2.91h-.066a1.2 1.2 0 00-1.098.727v0z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    